[
  {
    "id": "mostUsed",
    "icons": [
      { "id": "circle" },
      { "id": "5021_Baustelle" },
      { "id": "5022_Einfahrt_Verboten" },
      { "id": "201_Buslichtzeichen" },
      { "id": "202_Ampeln" },
      { "id": "204_Andreaskreuz" },
      { "id": "ersatzverkehr_io_v1" },
      { "id": "cross_v1" },
      { "id": "cross_black_v1" }
    ]
  },
  {
    "id": "RVF",
    "icons": [
      {
        "id": "naturenergie_sharing_v1"
      },
      {
        "id": "grueneflotte_v1"
      },
      {
        "id": "frelo_v1"
      }
    ]
  },
  {
    "id": "VAG",
    "icons": [
      {
        "id": "vag_abfahrt_v1"
      },
      {
        "id": "vag_achtung_v1"
      },
      {
        "id": "vag_aufzug_v1"
      },
      {
        "id": "vag_auto_v1"
      },
      {
        "id": "vag_bike_ride_v1"
      },
      {
        "id": "vag_bikesharing_v1"
      },
      {
        "id": "vag_briefkasten_v1"
      },
      {
        "id": "vag_buecherschrank_v1"
      },
      {
        "id": "vag_buergerbus_v1"
      },
      {
        "id": "vag_bus_v1"
      },
      {
        "id": "vag_carsharing_v1"
      },
      {
        "id": "vag_defibrillator_v1"
      },
      {
        "id": "vag_e_roller_v1"
      },
      {
        "id": "vag_essen_trinken_v1"
      },
      {
        "id": "vag_fahrrad_parkhaus_v1"
      },
      {
        "id": "vag_fahrrad_servicestation_v1"
      },
      {
        "id": "vag_fahrrad_v1"
      },
      {
        "id": "vag_fahrradbox_v1"
      },
      {
        "id": "vag_fahrradteile_automat_breiter_v1"
      },
      {
        "id": "vag_fahrradteile_automat_v1"
      },
      {
        "id": "vag_fairtiq_v1"
      },
      {
        "id": "vag_gemeinschaft_v1"
      },
      {
        "id": "vag_haltestelle_v1"
      },
      {
        "id": "vag_handicap_parken_v1"
      },
      {
        "id": "vag_handicap_v1"
      },
      {
        "id": "vag_info_v1"
      },
      {
        "id": "vag_kiss_ride_v1"
      },
      {
        "id": "vag_kreis_i_v1"
      },
      {
        "id": "vag_ladepunkt_akku_breiter_v1"
      },
      {
        "id": "vag_ladepunkt_akku_v1"
      },
      {
        "id": "vag_ladepunkt_auto_v1"
      },
      {
        "id": "vag_lastenfahrrad_v1"
      },
      {
        "id": "vag_lastenrad_parkplatz_v1"
      },
      {
        "id": "vag_mitfahrpunkt_breiter_v1"
      },
      {
        "id": "vag_mitfahrpunkt_v1"
      },
      {
        "id": "vag_mobiltelefon_v1"
      },
      {
        "id": "vag_mobilticket_abo_v1"
      },
      {
        "id": "vag_mobilticket_v1"
      },
      {
        "id": "vag_motorrad_parkplatz_v1"
      },
      {
        "id": "vag_packstation_v1"
      },
      {
        "id": "vag_park_ride_v1"
      },
      {
        "id": "vag_parken_fahrrad_v1"
      },
      {
        "id": "vag_parkhaus_v1"
      },
      {
        "id": "vag_pedelec_v1"
      },
      {
        "id": "vag_person_v1"
      },
      {
        "id": "vag_rauchverbot_v1"
      },
      {
        "id": "vag_rolltreppe_v1"
      },
      {
        "id": "vag_sammeltaxi_ast_v1"
      },
      {
        "id": "vag_schliessfach_v1"
      },
      {
        "id": "vag_seilbahn_v1"
      },
      {
        "id": "vag_stadtbahn_v1"
      },
      {
        "id": "vag_taxi_v1"
      },
      {
        "id": "vag_ticketautomat_v1"
      },
      {
        "id": "vag_tickets_v1"
      },
      {
        "id": "vag_treppenpfeile_1_1_v1"
      },
      {
        "id": "vag_treppenpfeile_1_2_v1"
      },
      {
        "id": "vag_treppenpfeile_1_3_v1"
      },
      {
        "id": "vag_treppenpfeile_1_4_v1"
      },
      {
        "id": "vag_treppenpfeile_2_1_v1"
      },
      {
        "id": "vag_treppenpfeile_2_2_v1"
      },
      {
        "id": "vag_treppenpfeile_2_3_v1"
      },
      {
        "id": "vag_treppenpfeile_2_4_v1"
      },
      {
        "id": "vag_treppenpfeile_2_5_v1"
      },
      {
        "id": "vag_treppenpfeile_2_6_v1"
      },
      {
        "id": "vag_trinkwasser_v1"
      },
      {
        "id": "vag_uhr_v1"
      },
      {
        "id": "vag_verkaufsstelle_v1"
      },
      {
        "id": "vag_warteraum_v1"
      },
      {
        "id": "vag_wc_v1"
      },
      {
        "id": "vag_wickeltisch_v1"
      },
      {
        "id": "vag_wlan_v1"
      },
      {
        "id": "vag_wohnmobil_stellplatz_v1"
      },
      {
        "id": "vag_zug_v1"
      }
    ]
  },
  {
    "id": "VAG Parkhaus",
    "icons": [
      {
        "id": "vag_parkhaus_blau_weiss_grau_v1"
      },
      {
        "id": "vag_parkhaus_blau_weiss_gruen_v1"
      },
      {
        "id": "vag_parkhaus_blau_weiss_orange_v1"
      },
      {
        "id": "vag_parkhaus_blau_weiss_rot_v1"
      },
      {
        "id": "vag_parkhaus_schwarz_grau_v1"
      },
      {
        "id": "vag_parkhaus_schwarz_gruen_v1"
      },
      {
        "id": "vag_parkhaus_schwarz_orange_v1"
      },
      {
        "id": "vag_parkhaus_schwarz_rot_v1"
      }
    ]
  },
  {
    "id": "01_Gleise",
    "icons": []
  },
  {
    "id": "Externe kommerzielle Einrichtungen",
    "icons": [
      {
        "id": "Nr.1_8_001-1_v1"
      },
      {
        "id": "Nr.2_8_010-1_v1"
      },
      {
        "id": "Nr.3_8_011-1_v1"
      },
      {
        "id": "Nr.4_8_012-1_v1"
      },
      {
        "id": "Nr.5_8_020-1_v1"
      }
    ]
  },
  {
    "id": "Information zur Reisekette 1",
    "icons": [
      {
        "id": "Nr.10_1_020-1_v1"
      },
      {
        "id": "Nr.11_1_021-1_v1"
      },
      {
        "id": "Nr.12_1_022-1_v1"
      },
      {
        "id": "Nr.13_1_023-1_v1"
      },
      {
        "id": "Nr.14_1_030-1_v1"
      },
      {
        "id": "Nr.15_1_031-1_v1"
      },
      {
        "id": "Nr.16_1_040-1_v1"
      },
      {
        "id": "Nr.17_1_041-1_v1"
      },
      {
        "id": "Nr.17_1_042-1_v1"
      },
      {
        "id": "Nr.19_1_043-1_v1"
      },
      {
        "id": "Nr.20_1_044-1_v1"
      },
      {
        "id": "Nr.1_1_001-1_v1"
      },
      {
        "id": "Nr.2_1_002-1_v1"
      },
      {
        "id": "Nr.3_1_003-1_v1"
      },
      {
        "id": "Nr.4_1_004-1_v1"
      },
      {
        "id": "Nr.5_1_005-1_v1"
      },
      {
        "id": "Nr.6_1_006-1_v1"
      },
      {
        "id": "Nr.7_1_007-1_v1"
      },
      {
        "id": "Nr.8_1_008-1_v1"
      },
      {
        "id": "Nr.9_1_009-1_v1"
      }
    ]
  },
  {
    "id": "Information zur Reisekette 2",
    "icons": [
      {
        "id": "Nr.10_4_061-1_v1"
      },
      {
        "id": "Nr.11_4_070-1_v1"
      },
      {
        "id": "Nr.1_4_001-1_v1"
      },
      {
        "id": "Nr.2_4_002-1_v1"
      },
      {
        "id": "Nr.3_4_010-1_v1"
      },
      {
        "id": "Nr.4_4_011-1_v1"
      },
      {
        "id": "Nr.5_4_012-1_v1"
      },
      {
        "id": "Nr.6_4_013-1_v1"
      },
      {
        "id": "Nr.7_4_014-1_v1"
      },
      {
        "id": "Nr.8_4_050-1_v1"
      },
      {
        "id": "Nr.9_4_060-1_v1"
      }
    ]
  },
  {
    "id": "Interne kommerzielle Einrichtungen",
    "icons": [
      {
        "id": "Nr.10_7_025-1_v1"
      },
      {
        "id": "Nr.11_7_030-1_v1"
      },
      {
        "id": "Nr.12_7_031-1_v1"
      },
      {
        "id": "Nr.1_7_001-1_v1"
      },
      {
        "id": "Nr.2_7_002-1_v1"
      },
      {
        "id": "Nr.3_7_003-1_v1"
      },
      {
        "id": "Nr.4_7_010-1_v1"
      },
      {
        "id": "Nr.5_7_020-1_v1"
      },
      {
        "id": "Nr.6_7_021-1_v1"
      },
      {
        "id": "Nr.7_7_022-1_v1"
      },
      {
        "id": "Nr.8_7_023-1_v1"
      },
      {
        "id": "Nr.9_7_024-1_v1"
      }
    ]
  },
  {
    "id": "Lageplan",
    "icons": [
      {
        "id": "Nr.1_9_001-1_v1"
      },
      {
        "id": "Nr.2_9_002-1_v1"
      },
      {
        "id": "Nr.3_9_003-1_v1"
      },
      {
        "id": "Nr.4_9_004-1_v1"
      }
    ]
  },
  {
    "id": "Serviceeinrichtungen",
    "icons": [
      {
        "id": "Nr.10_5_024-1_v1"
      },
      {
        "id": "Nr.11_5_025-1_v1"
      },
      {
        "id": "Nr.12_5_030-1_v1"
      },
      {
        "id": "Nr.13_5_031-1_v1"
      },
      {
        "id": "Nr.14_5_040-1_v1"
      },
      {
        "id": "Nr.15_5_050-1_v1"
      },
      {
        "id": "Nr.16_5_051-1_v1"
      },
      {
        "id": "Nr.17_5_052-1_v1"
      },
      {
        "id": "Nr.18_5_060-1_v1"
      },
      {
        "id": "Nr.19_5_061-1_v1"
      },
      {
        "id": "Nr.1_5_001-1_v1"
      },
      {
        "id": "Nr.20_5_062-1_v1"
      },
      {
        "id": "Nr.2_5_002-1_v1"
      },
      {
        "id": "Nr.3_5_010-1_v1"
      },
      {
        "id": "Nr.4_5_018-1_v1"
      },
      {
        "id": "Nr.5_5_019-1_v1"
      },
      {
        "id": "Nr.6_5_020-1_v1"
      },
      {
        "id": "Nr.7_5_021-1_v1"
      },
      {
        "id": "Nr.8_5_022-1_v1"
      },
      {
        "id": "Nr.9_5_023-1_v1"
      }
    ]
  },
  {
    "id": "Sicherheitseinrichtungen",
    "icons": [
      {
        "id": "Nr.1_2_001-1_v1"
      },
      {
        "id": "Nr.2_2_010-1_v1"
      },
      {
        "id": "Nr.3_2_020-1_v1"
      },
      {
        "id": "Nr.4_2_030-1_v1"
      },
      {
        "id": "Nr.5_2_040-1_v1"
      },
      {
        "id": "Nr.6_2_050-1_v1"
      },
      {
        "id": "Nr.7_2_060-1_v1"
      }
    ]
  },
  {
    "id": "01_Verkehrsmittel",
    "icons": [
      {
        "id": "Nr.10_3_061-1_v1"
      },
      {
        "id": "Nr.11_3_062-1_v1"
      },
      {
        "id": "Nr.12_3_070-1_v1"
      },
      {
        "id": "Nr.13_3_080-1_v1"
      },
      {
        "id": "Nr.14_3_090-1_v1"
      },
      {
        "id": "Nr.15_3_091-1_v1"
      },
      {
        "id": "Nr.16_3_092-1_v1"
      },
      {
        "id": "Nr.1_3_001-1_v1"
      },
      {
        "id": "Nr.2_3_002-1_v1"
      },
      {
        "id": "Nr.3_3_010-1_v1"
      },
      {
        "id": "Nr.4_3_020-1_v1"
      },
      {
        "id": "Nr.5_3_030-1_v1"
      },
      {
        "id": "Nr.6_3_040-1_v1"
      },
      {
        "id": "Nr.7_3_041-1_v1"
      },
      {
        "id": "Nr.8_3_050-1_v1"
      },
      {
        "id": "Nr.9_3_060-1_v1"
      }
    ]
  }
]
